import { render, staticRenderFns } from "./ResponsiveModalNew.vue?vue&type=template&id=97b62b2e&scoped=true&"
import script from "./ResponsiveModalNew.vue?vue&type=script&lang=js&"
export * from "./ResponsiveModalNew.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveModalNew.vue?vue&type=style&index=0&id=97b62b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b62b2e",
  null
  
)

export default component.exports